module.exports = __webpack_public_path__ + "img/kongzi big (1).019395f5.jpg";